var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _rect2, _rect3, _rect4, _path19, _path20, _path21, _rect5, _path22, _path23, _rect6, _path24, _rect7, _path25, _rect8, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern07(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1895.75 895.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pattern07") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 696.57,
    cy: 716,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 719.57,
    cy: 704,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 742.57,
    cy: 691,
    r: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 708.57,
    cy: 738,
    r: 6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 731.57,
    cy: 726,
    r: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 754.57,
    cy: 713,
    r: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 720.57,
    cy: 761,
    r: 6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 743.57,
    cy: 749,
    r: 6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 766.57,
    cy: 736,
    r: 6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1244.57,
    cy: 384,
    r: 6
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1267.57,
    cy: 372,
    r: 6
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1290.57,
    cy: 359,
    r: 6
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1256.57,
    cy: 406,
    r: 6
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1279.57,
    cy: 394,
    r: 6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1302.57,
    cy: 381,
    r: 6
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1268.57,
    cy: 429,
    r: 6
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1291.57,
    cy: 417,
    r: 6
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1314.57,
    cy: 404,
    r: 6
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 445.98,
    cy: 293.49,
    r: 9.12
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 485.29,
    cy: 290.17,
    r: 9.12
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 525.19,
    cy: 285.45,
    r: 9.12
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 449.89,
    cy: 331.4,
    r: 9.12
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.2,
    cy: 328.08,
    r: 9.12
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 529.1,
    cy: 323.35,
    r: 9.12
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 453.21,
    cy: 370.71,
    r: 9.12
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 492.52,
    cy: 367.39,
    r: 9.12
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 532.42,
    cy: 362.66,
    r: 9.12
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1025.68,
    cy: 48.19,
    r: 5.96,
    transform: "translate(416.56 874.82) rotate(-56.3)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1051.33,
    cy: 48.69,
    r: 5.96
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1077.55,
    cy: 48.34,
    r: 5.96
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1025.63,
    cy: 73.07,
    r: 5.96,
    transform: "translate(395.83 885.86) rotate(-56.3)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1051.28,
    cy: 73.56,
    r: 5.96
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1077.5,
    cy: 73.22,
    r: 5.96
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1025.1,
    cy: 98.82,
    r: 5.96,
    transform: "translate(374.17 896.89) rotate(-56.3)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1050.75,
    cy: 99.31,
    r: 5.96
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1076.98,
    cy: 98.97,
    r: 5.96
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1074.57,
    cy: 504,
    r: 9
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1437.57,
    cy: 437,
    r: 9
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1304.57,
    cy: 656,
    r: 9
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1399.07,
    cy: 277.5,
    r: 4.5
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 820.07,
    cy: 209.5,
    r: 19.5
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 691.07,
    cy: 513.5,
    r: 19.5
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1789.57,
    cy: 835,
    r: 15
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 253.58,
    cy: 495,
    r: 9,
    transform: "translate(-275.65 666.02) rotate(-80.78)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 957.07,
    cy: 424.5,
    r: 4.5
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 336.07,
    cy: 8.5,
    r: 8.5
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 686.07,
    cy: 187.5,
    r: 3.5
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 735.07,
    cy: 41.5,
    r: 4.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1507.57 584 1510.57 689 1599.57 634 1507.57 584"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.83,611.25a74.26,74.26,0,0,1-137.71,38.57l19-11.63A52,52,0,0,0,397,584.14h0l-.17-.28,19-11.63A73.87,73.87,0,0,1,426.83,611.25Z",
    transform: "translate(-0.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1609.89,76.25a74.26,74.26,0,0,1,19.48,141.68l-8.94-20.39a52,52,0,0,0-40.66-95.72c-.37.15-.73.31-1.1.48l-8.94-20.39A74,74,0,0,1,1609.89,76.25Z",
    transform: "translate(-0.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.19,791.2A53.64,53.64,0,0,1,1363,715l-7.21,14.37a37.56,37.56,0,0,0-33.7,67.14h0l-7.21,14.37A53.38,53.38,0,0,1,1293.19,791.2Z",
    transform: "translate(-0.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.35,82.09,496.23,64.75h0A41.58,41.58,0,0,1,538.35,82.1Z",
    transform: "translate(-0.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545,98.35,479.7,71.92a40.49,40.49,0,0,1,7.55-4.36h0l55,21.55h0A40.75,40.75,0,0,1,545,98.35Z",
    transform: "translate(-0.01)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.58,105.5a41.88,41.88,0,0,1-.54,6.71h0L469.81,82.09a41.74,41.74,0,0,1,4.8-5.81l70.94,28C545.58,104.71,545.58,105.1,545.58,105.5Z",
    transform: "translate(-0.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.78,117.63a42.29,42.29,0,0,1-2.9,7.08L464.34,93.53A38.67,38.67,0,0,1,467,86.87Z",
    transform: "translate(-0.01)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.1,129.27a41.12,41.12,0,0,1-5.18,6.07l-70.34-28.13V105.5a42.1,42.1,0,0,1,.41-5.83Z",
    transform: "translate(-0.01)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.39,139.13a41.19,41.19,0,0,1-8.42,4.72l-54.16-22.29a40.81,40.81,0,0,1-2.5-8.24Z",
    transform: "translate(-0.01)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.5,146.34a42,42,0,0,1-7.42.66,41.4,41.4,0,0,1-33.85-17.49Z",
    transform: "translate(-0.01)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1818.39,383.4l-30.35,34h0a41.56,41.56,0,0,1,30.36-34Z",
    transform: "translate(-0.01)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1835.92,382.57l-46.61,52.77a40.89,40.89,0,0,1-1.61-8.57h0l38.58-44.67h0A40.94,40.94,0,0,1,1835.92,382.57Z",
    transform: "translate(-0.01)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.87,384.36a40.73,40.73,0,0,1,6.15,2.74l-.06.06L1795.58,448a41,41,0,0,1-3.88-6.45l50-57.6Z",
    transform: "translate(-0.01)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1853.71,390.09a40.59,40.59,0,0,1,5.72,5.08L1804.58,457a39.71,39.71,0,0,1-5.39-4.72Z",
    transform: "translate(-0.01)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1862.8,399.31a42,42,0,0,1,4,6.9l-49.9,57-1.62-.54a41.68,41.68,0,0,1-5.36-2.32Z",
    transform: "translate(-0.01)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1868.88,411.75a41.47,41.47,0,0,1,1.65,9.51l-39,43.67a40.59,40.59,0,0,1-8.6-.38Z",
    transform: "translate(-0.01)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1870.06,430.07a41.53,41.53,0,0,1-29.58,33.33Z",
    transform: "translate(-0.01)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.52,322.56l80.42,90a14.35,14.35,0,0,1-1.14,20.26h0a14.35,14.35,0,0,1-20.26-1.14l-80.42-90a14.35,14.35,0,0,1,1.14-20.26h0A14.37,14.37,0,0,1,843.52,322.56Z",
    transform: "translate(-0.01)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 957.26,
    y: 670.64,
    width: 143.67,
    height: 28.69,
    rx: 14.34,
    ry: 14.34,
    transform: "translate(-167.43 995.8) rotate(-48.21)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1156.34,
    y: 241.03,
    width: 63.03,
    height: 35.46,
    rx: 17.64,
    ry: 17.64,
    transform: "translate(203.33 971.98) rotate(-48.21)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.36,
    y: 173.04,
    width: 63.03,
    height: 35.46,
    rx: 17.64,
    ry: 17.64,
    transform: "translate(-69.23 226.83) rotate(-48.21)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1733.24,
    y: 702.64,
    width: 143.67,
    height: 28.69,
    rx: 14.34,
    ry: 14.34,
    transform: "translate(67.58 1585.03) rotate(-48.21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1794.07,750.28l76.64-85.74a14.35,14.35,0,0,1,20.26-1.11h0a14.34,14.34,0,0,1,1.14,20.25l-76.64,85.74a14.33,14.33,0,0,1-20.24,1.13h0a14.34,14.34,0,0,1-1.13-20.25Z",
    transform: "translate(-0.01)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.93,698,214.32,816a18.92,18.92,0,0,1-1.49,26.72h0a18.93,18.93,0,0,1-26.72-1.48v0l-105.39-118a18.93,18.93,0,0,1,1.48-26.72h0A18.93,18.93,0,0,1,108.93,698Z",
    transform: "translate(-0.01)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.8,692,159.13,811a18.93,18.93,0,0,1-1.49,26.73h0a18.94,18.94,0,0,1-26.73-1.5l-106.34-119a18.93,18.93,0,0,1,1.5-26.72h0A18.93,18.93,0,0,1,52.79,692Z",
    transform: "translate(-0.01)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1772.18,
    y: 64.24,
    width: 35.46,
    height: 63.03,
    rx: 17.64,
    ry: 17.64,
    transform: "translate(391.55 1217.16) rotate(-41.79)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.1,39.71,45.48,125.43a14.34,14.34,0,0,1-20.25,1.14h0a14.35,14.35,0,0,1-1.14-20.26l76.62-85.72A14.36,14.36,0,0,1,121,19.43l0,0h0A14.37,14.37,0,0,1,122.1,39.71Z",
    transform: "translate(-0.01)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.1,39.71,83.48,125.44a14.37,14.37,0,0,1-20.26,1.14h0a14.35,14.35,0,0,1-1.13-20.26L138.71,20.6A14.35,14.35,0,0,1,159,19.43l0,0h0a14.33,14.33,0,0,1,1.11,20.25Z",
    transform: "translate(-0.01)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1372.65,
    y: 10.69,
    width: 13.23,
    height: 195.89,
    rx: 6.61,
    ry: 6.61,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 265.18, 929)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1295.71,2.77l15,17.39a6.41,6.41,0,0,1-.65,9h0a6.41,6.41,0,0,1-9-.65l-15-17.4a6.37,6.37,0,0,1,.65-9h0A6.4,6.4,0,0,1,1295.71,2.77Z",
    transform: "translate(-0.01)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 579.65,
    y: 780.07,
    width: 13.23,
    height: 129.87,
    rx: 6.61,
    ry: 6.61,
    transform: "translate(-409.1 586.16) rotate(-40.67)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.58,763.88l15,17.45a6.39,6.39,0,0,1-.68,9h0a6.39,6.39,0,0,1-9-.68l-15-17.45a6.39,6.39,0,0,1,.68-9h0A6.39,6.39,0,0,1,524.58,763.88Z",
    transform: "translate(-0.01)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -11.71,
    y: 381.53,
    width: 110.24,
    height: 13.23,
    rx: 6.61,
    ry: 6.61,
    transform: "translate(-242.48 122.04) rotate(-40.67)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122,329.07l-17.44,15a6.39,6.39,0,0,1-9-.68h0a6.39,6.39,0,0,1,.68-9l17.45-15a6.39,6.39,0,0,1,9,.68h0A6.39,6.39,0,0,1,122,329.07Z",
    transform: "translate(-0.01)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern07);
export default __webpack_public_path__ + "static/media/pattern07.b99d88d4dcc27ac788b831971660f042.svg";
export { ForwardRef as ReactComponent };